const resources = {
    representative: 'Des représentant(e)s sont disponibles :',
    monFriTime: 'de 5 h à 21 h HP',
    satSunTime: '6am - 9pm PT',
    monFri: 'MON-FRI',
    satSun: 'SAT-SUN',
    chatWithUs: 'Clavardez avec nous'
};

export default function getResource(label) {
    return resources[label];
}
